import React from "react";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { UserContext } from "../../../context/UserContext";
import EditIcon from "@mui/icons-material/Edit";
import { StyledButton } from "../../common/Buttons";
import { Grid, Stack } from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import PublicIcon from "@mui/icons-material/Public";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import DescriptionIcon from "@mui/icons-material/Description";
import {
  cleanUrl,
  CompactDirectoryCard,
  mailHref,
  phoneHref,
  TagButton,
  useWideCards,
} from "../Directory/DirectoryCard";

function Provider(props: any) {
  const provider = props.providerContent;
  const { user } = React.useContext(UserContext);
  const wide = useWideCards();
  const selectedProviderFlag = props.selectedProvider.find((p: any) => {
    return p.orgName === provider.orgName;
  });

  const openNotesEditor = (resource: any) => {
    props.setEditingResource({ ...provider, provider_id: resource.id });
    props.setProviderNotesOpen(true);
  };

  function openEditModal(resource: any) {
    props.setEditingResource({ ...provider, provider_id: resource.id });
    props.setResourceEditorOpen(true);
  }

  const toggleSelected = () => {
    props.setSelectedProvider(
      selectedProviderFlag
        ? props.selectedProvider.filter(
            (p: any) => p.orgName !== provider.orgName
          )
        : [...props.selectedProvider, provider]
    );
  };

  const openHistory = () => {
    props.setHisOpen(true);
    props.setHisProvider(provider);
  };

  const openFactSheet = () => {
    props.setProviderFactsheetOpen(true);
    props.setEditingResource(provider);
  };

  const imageSrc =
    provider.imagePath ||
    `${process.env.REACT_APP_API_DOMAIN}/images/dummy-image.jpg`;

  const description = provider.description ? (
    <ul style={{ listStyleType: "circle" }}>
      {provider.description.split(",").map((item: any, index: number) => {
        return <li key={index}>{item}</li>;
      })}
    </ul>
  ) : (
    "No description available"
  );

  if (!wide) {
    const contactName = [provider.firstName, provider.lastName]
      .filter(Boolean)
      .join(" ");
    const isAdmin = user.role === "admin";
    return (
      <CompactDirectoryCard
        selected={Boolean(selectedProviderFlag)}
        imageSrc={imageSrc}
        title={
          contactName ? `${provider.orgName} - ${contactName}` : provider.orgName
        }
        onTitleClick={openHistory}
        onEdit={isAdmin ? () => openEditModal(provider) : undefined}
        onNotes={isAdmin ? () => openNotesEditor(provider) : undefined}
        actions={[
          {
            key: "select",
            label: selectedProviderFlag ? "Unselect" : "Select Provider",
            onClick: toggleSelected,
          },
          provider.onepagerPath && {
            key: "one-pager",
            label: "View One Pager",
            href: provider.onepagerPath,
          },
          provider.factsheets && {
            key: "fact-sheet",
            label: "View Fact Sheet",
            onClick: openFactSheet,
          },
          provider.notes && {
            key: "notes",
            label: "View Notes",
            onClick: () => openNotesEditor(provider),
          },
        ]}
        contacts={[
          {
            key: "website",
            icon: <PublicIcon fontSize="small" />,
            text: provider.url,
            href: cleanUrl(provider.url),
            newTab: true,
          },
          {
            key: "phone",
            icon: <PhoneIcon fontSize="small" />,
            text: provider.phone,
            href: phoneHref(provider.phone),
          },
          {
            key: "email",
            icon: <MailOutlineIcon fontSize="small" />,
            text: provider.email,
            href: mailHref(provider.email),
          },
          provider.calendarLink && {
            key: "calendar",
            icon: <CalendarMonthIcon fontSize="small" />,
            text: "Schedule Meeting",
            href: cleanUrl(provider.calendarLink),
            newTab: true,
          },
          {
            key: "address",
            icon: <LocationOnIcon fontSize="small" />,
            text: provider.address,
          },
        ]}
        description={description}
        tags={props.tagDisplay ? provider.tags : undefined}
        onTagClick={props.handleTagClick}
      />
    );
  }

  return (
    <div
      className={`bg-white rounded-lg shadow-md pb-2 pt-2 ${selectedProviderFlag ? "border-2 border-magenta" : ""
        }`}
    >
      <div className="grid grid-cols-3 gap-2">
        {/* <h3 className={styles.title}>{resource.title}</h3> */}
        <div className="col-start-1 col-span-1">
          <div className="flex flex-col">
            <div className="w-60 h-60 bg-white flex items-center justify-center rounded-lg m-1">
              <img
                src={imageSrc}
                className="object-contain w-full h-full"
                alt="Resource"
              />
            </div>

            <div className="flex flex-col items-start ml-2">
              <StyledButton
                className="bg-gray-300 hover:bg-gray-300 font-bold py-2 w-[220px] rounded-xl hover:cursor-pointer mt-2"
                sx={{ color: "white" }}
                onClick={toggleSelected}
              >
                {selectedProviderFlag ? "Unselect" : "Select Provider"}
              </StyledButton>
              {provider.onepagerPath && (
                <>
                  <a
                    className="bg-yellow hover:bg-magenta text-white font-bold py-2 w-[220px] rounded-xl hover:cursor-pointer mt-2"
                    href={provider.onepagerPath}
                    target="_blank"
                  >
                    View One Pager
                  </a>
                </>
              )}
              {provider.factsheets && (
                <>
                  <button
                    className="bg-yellow hover:bg-magenta text-white font-bold py-2 w-[220px] rounded-xl hover:cursor-pointer mt-2"
                    onClick={openFactSheet}
                  >
                    View Fact Sheet
                  </button>
                </>
              )}
              {provider.notes && (
                <>
                  <button
                    className="bg-yellow hover:bg-magenta text-white font-bold py-2 w-[220px] rounded-xl hover:cursor-pointer mt-2"
                    onClick={() => {
                      openNotesEditor(provider);
                    }}
                  >
                    View Notes
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="col-start-2 col-span-2">
          <div className="flex flex-col items-start h-full">
            <div className="w-full">
              <Stack
                direction="row"
                spacing={1}
                // sx={{ width: "100%", display: "block" }}
                justifyContent={"space-between"}
              >
                <h3
                  className="text-lg font-bold text-left"
                  style={{ float: "left", cursor: "pointer" }}
                  onClick={openHistory}
                >
                  {provider.orgName} -{" "}
                  {provider.firstName + " " + provider.lastName}
                </h3>
                {user.role === "admin" && (
                  <Stack direction={"row"} spacing={0} sx={{ width: "100px" }}>
                    <div
                      style={{ width: "50px", height: "50px" }}
                      className="cursor-pointer"
                      onClick={() => {
                        openEditModal(provider);
                      }}
                    >
                      <EditIcon className="text-magenta " />
                    </div>
                    <div
                      style={{ width: "50px", height: "50px" }}
                      className="cursor-pointer"
                      onClick={() => {
                        openNotesEditor(provider);
                      }}
                    >
                      <DescriptionIcon className="text-magenta " />
                    </div>
                  </Stack>
                )}
              </Stack>
              {/* thrive-user-text: long websites and emails wrap in their cell */}
              <Grid container spacing={2} textAlign={"left"}>
                <Grid item xs={6} className="thrive-user-text">
                  <PublicIcon fontSize="small"></PublicIcon>
                  <a target="_blank" href={cleanUrl(provider.url)}>
                    {provider.url}
                  </a>
                </Grid>
                <Grid item xs={6} className="thrive-user-text">
                  <PhoneIcon fontSize="small"></PhoneIcon>
                  {provider.phone}
                </Grid>
                <Grid item xs={6} className="thrive-user-text">
                  <MailOutlineIcon fontSize="small"></MailOutlineIcon>
                  <a href={`mailto:${provider.email}`}>{provider.email}</a>
                </Grid>
                {provider.calendarLink && (
                  <Grid item xs={6} className="thrive-user-text">
                    <CalendarMonthIcon fontSize="small"></CalendarMonthIcon>
                    <a target="_blank" href={cleanUrl(provider.calendarLink)}>
                      Schedule Meeting
                    </a>
                  </Grid>
                )}

                <Grid item xs={6} className="thrive-user-text">
                  <LocationOnIcon fontSize="small"></LocationOnIcon>
                  {provider.address}
                </Grid>
              </Grid>
            </div>
            <div className="m-2">
              <h3 className="text-sm text-justify thrive-user-text">
                {description}
              </h3>
            </div>

            {/* tags */}
            {props.tagDisplay && provider.tags ? (
              <div className="mt-auto flex justify-left flex-wrap">
                {provider.tags.map((tag: any, index: number) => (
                  <TagButton
                    key={index}
                    tag={tag}
                    onClick={() => props.handleTagClick(tag)}
                  />
                ))}
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </div >
  );
}

export default Provider;
